import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { ProposalSubscription } from '~/graphql/types'

@Module({
  name: 'proposal-sent',
  stateFactory: true,
  namespaced: true,
})
export default class ProposalSent extends VuexModule {
  fetchStarted = false
  loading = true
  items: ProposalSubscription['cart'] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
